import script from "./dropdownButton.vue?vue&type=script&lang=js"
export * from "./dropdownButton.vue?vue&type=script&lang=js"

import "./dropdownButton.vue?vue&type=style&index=0&id=23ac87be&lang=scss"

const __exports__ = script;

export default __exports__